import * as React from 'react'
import { connect } from 'react-redux'
import { handleOpeningHours } from '../../../utils/openingHours'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { RootState, Dispatch } from '../../../app/store'
import type { StoreT, StatusT } from '../../../models/store'
import Loading from '../../Loading'
import MessageBanner from '../../MessageBanner'
import styles from './Start.module.css'
interface StartT {
  fetchStore: (payload: string) => void,
  setTableNumber: (payload: string) => void,
  store: StoreT | null,
  status: StatusT,
}

function Start ({ fetchStore, store, status, setTableNumber }: StartT) {
  const { search, pathname } = useLocation()
  const tableNumber = new URLSearchParams(search).getAll('bord')[0]
  localStorage.setItem('cartId', '')


  const { storeId } = useParams()
  const navigate = useNavigate()
  const { logo, description, openingHours, backgroundUrl } = store || {}
  const backgroundImg = backgroundUrl
    ? `url(${backgroundUrl})`
    : 'url(/start-bg.jpg)'
  const [storeIsOpen, setStoreIsOpen] = React.useState(false)
  const { openingDetails }: { openingDetails: { opening?: string } } = handleOpeningHours(openingHours || [])

  const getStore = React.useCallback(() => {
    if (storeId) {
      fetchStore(storeId)
    }
  }, [fetchStore, storeId])

  React.useEffect(() => {
    getStore()
  }, [getStore])

  React.useEffect(() => {
    const { isOpen } = handleOpeningHours(openingHours || [])
    if (isOpen !== storeIsOpen) {
      setStoreIsOpen(isOpen)
    }
  }, [storeIsOpen, openingHours])

  React.useEffect(() => {
    if (storeIsOpen) {
      if (tableNumber) {
        setTableNumber(tableNumber)
      }
      navigate(`/butik/${storeId}/restaurant`)
    }
  }, [storeIsOpen, tableNumber, setTableNumber])

  const infoTexts = React.useMemo(() => {
    if (openingDetails.opening) {
      return {
        text: `Köket öppnar ${openingDetails.opening}`,
        title: 'Öppettider',
        greeting: 'Välkommen då!',
      }
    } else {
      return {
        text: 'Köket är tyvärr stängt just nu',
        title: 'Öppettider',
        greeting: 'Välkommen tillbaka!',
      }
    }
  }, [])

  return status === 'FETCHING' ? (
    <div style={{
      backgroundImage: 'url(/start-bg.jpg)'
    }} className={styles.page}>
      <Loading />
    </div>
  ) : !storeIsOpen && (
    <div style={{
      backgroundImage: backgroundImg,
    }} className={styles.page}>
      <div className={styles.content}>
        {logo && (
          <a className={styles.link} href={pathname}>
            <img className={styles.logo} src={logo} alt="Restaurangens logo" />
          </a>
        )}
        <p className={styles.preamble}>{description}</p>
        {
          <>
            <MessageBanner title={infoTexts.title} description={`${infoTexts.text} ${infoTexts.greeting}`} maxWidth={'585px'} />
          </>
        }
      </div>
    </div>
  )
}

function mapState (state: RootState) {
  return {
    status: state.store.status,
    store: state.store.current
  }
}

function mapDispatch (dispatch: Dispatch) {
  return {
    setTableNumber: dispatch.cart.setTableNumber,
    fetchStore: dispatch.store.fetchStore,
  }
}

export default connect(mapState, mapDispatch)(Start)
